import useTranslate from "../../hooks/use-translate"

export const Translate = (props) => {
    return useTranslate(props.id)

}

export default Translate;